import React, { useState } from "react";

const ReminderPlatformMessages = ({ reminder, onUpdate }) => {
    const [activePlatform, setActivePlatform] = useState("email");

    const messages = reminder.platformMessages || {};

    const updatePlatformMessage = ( platform, field, value ) => {
        onUpdate({
            platformMessages: {
                ...messages,
                [platform]: { ...messages[platform], [field]: value },
            },
        });
    };

    return (
        <div className="platform-messages">
            <div className="subsection-heading">
                <div>
                    <strong>
                        Platform specific messages
                    </strong>

                    <span>
                        Create a different message for each delivery channel.
                    </span>
                </div>
            </div>

            {/* PLATFORM TABS */}

            <div className="platform-tabs">
                {[
                    ["email", "Email"],
                    ["whatsapp", "WhatsApp"],
                    ["sms", "SMS"],
                ].map(
                    ([value, label]) => {
                        const enabled = reminder.channels.includes(value);

                        return (
                            <button
                                key={value}
                                type="button"
                                disabled={!enabled}
                                className={
                                    activePlatform === value ? "active" : ""
                                }
                                onClick={() => setActivePlatform(value) }
                            >
                                {label}

                                {!enabled && (
                                    <span>
                                        Disabled
                                    </span>
                                )}
                            </button>
                        );
                    }
                )}
            </div>

            {/* EMAIL */}

            {activePlatform ===
                "email" && (
                <div className="platform-editor">
                    <div className="form-group">
                        <label>
                            Email subject
                        </label>

                        <input
                            type="text"
                            value={ messages.email?.subject || "" }
                            onChange={(e) =>
                                updatePlatformMessage(
                                    "email",
                                    "subject",
                                    e.target
                                        .value
                                )
                            }
                            placeholder="Payment reminder - {{payment_title}}"
                        />
                    </div>

                    <div className="form-group">
                        <label>
                            Email message
                        </label>

                        <textarea
                            value={ messages.email?.message || "" }
                            onChange={(e) =>
                                updatePlatformMessage(
                                    "email",
                                    "message",
                                    e.target
                                        .value
                                )
                            }
                            placeholder="Dear {{client_name}}, this is a reminder regarding your payment..."
                            rows="7"
                        />
                    </div>
                </div>
            )}

            {/* WHATSAPP */}

            {activePlatform ===
                "whatsapp" && (
                <div className="platform-editor">
                    <div className="form-group">
                        <label>
                            WhatsApp message
                        </label>

                        <textarea
                            value={ messages.whatsapp?.message || "" }
                            onChange={(e) =>
                                updatePlatformMessage(
                                    "whatsapp",
                                    "message",
                                    e.target
                                        .value
                                )
                            }
                            placeholder="Hi {{client_name}}, this is a friendly reminder..."
                            rows="7"
                        />
                    </div>
                </div>
            )}

            {/* SMS */}

            {activePlatform ===
                "sms" && (
                <div className="platform-editor">
                    <div className="form-group">
                        <label>
                            SMS message
                        </label>

                        <textarea
                            value={ messages.sms?.message || "" }
                            onChange={(e) =>
                                updatePlatformMessage(
                                    "sms",
                                    "message",
                                    e.target
                                        .value
                                )
                            }
                            placeholder="Reminder: payment of {{amount}} is due on {{due_date}}."
                            rows="5"
                            maxLength={320}
                        />

                        <div className="character-count">
                            {messages.sms?.message?.length || 0}{" "}/ 320
                        </div>
                    </div>
                </div>
            )}

            <div className="platform-message-help">
                <strong>
                    Tip
                </strong>

                <span>
                    If you leave a platform message empty, the default reminder message can be used for that platform.
                </span>
            </div>
        </div>
    );
};

export default ReminderPlatformMessages;
